import { io } from "socket.io-client";
import { ref } from "vue";
import { auth } from "./auth";
import VARS from "@/services/vars"

const SOCKET_URL = VARS.SOCKET_URL

const socketRef = ref(null);
const connected = ref(false);

export function useAgentSocket() {
  function connect() {
    if (socketRef.value?.connected) return socketRef.value;

    socketRef.value = io(SOCKET_URL, {
      auth: {
        type: "agent",
        token: auth.token,
      },
      transports: ["websocket"],
    });

    socketRef.value.on("connect", () => {
      connected.value = true;

      if (auth.user) {
        socketRef.value.emit("agent:join", {
          userId: auth.user.id,
          tenantId: auth.user.tenant_id,
          role: auth.user.role,
          socket_id : socketRef.value.id,

        });
      }
    });

    socketRef.value.on("disconnect", () => {
      connected.value = false;
    });

    socketRef.value.on("connect_error", (err) => {
      connected.value = false;
      console.log("socket connect_error:", err?.message || err);
    });

    return socketRef.value;
  }

  function disconnect() {
    if (socketRef.value) {
      socketRef.value.disconnect();
      socketRef.value = null;
    }
    connected.value = false;
  }

  return {
    socket: socketRef,
    connected,
    connect,
    disconnect,
  };
}